import { Flex, styled } from '@withjoy/joykit';
import { pxToRem } from '@shared/joykit/packages/core/common';

export const ContainerWrapper = styled(Flex)`
  margin-left: auto;
  margin-right: auto;
  gap: ${pxToRem(24)};
  margin-top: ${pxToRem(28)};
`;
export const CustomContainerWrapper = styled(Flex)<{ designType: 'fullRow' | 'widget'; useShadow?: boolean; forceFullWidth?: boolean; hasUrl?: boolean }>`
  min-height: ${pxToRem(352)};
  height: 100%;
  ${props => (props.designType === 'fullRow' ? 'margin-left: auto;' : '')}
  ${props => (props.designType === 'fullRow' ? 'margin-right: auto;' : '')}
  ${props =>
    props.useShadow
      ? `border-radius: 12px;
         box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.03), 0px 10px 60px -20px rgba(44, 41, 37, 0.03), 0px 9px 36px -30px rgba(0, 0, 0, 0.04);`
      : ''}
  overflow: hidden;
  width: 100%;
  max-width: ${props => {
    if (props.designType === 'fullRow') return pxToRem(840);
    if (props.forceFullWidth) return '100%';
    return `calc(50% - ${pxToRem(24)})`;
  }};
  flex-direction: ${props => (props.designType === 'fullRow' ? 'row' : 'column')};
  cursor: ${props => (props.hasUrl ? 'pointer' : 'default')};

  ${props => props.theme.mediaQueries.down({ viewport: 'sm' })} {
    max-width: 100%;
    width: 100%;
  }
`;
export const Thumbnail = styled.img<{ height?: string }>`
  width: 100%;
  object-fit: cover;
  object-position: center;
  ${props => (props.height ? `height: ${props.height}` : '')};
`;

export const FeaturedPopularTourWrapper = styled(Flex)<{ isLast: boolean }>`
  padding-top: ${pxToRem(16)};
  padding-bottom: ${pxToRem(16)};
  gap: ${pxToRem(8)};
  border-bottom: ${props => (props.isLast ? 'none' : `1px solid ${props.theme.colors.mono3}`)};
  cursor: pointer;
`;
